module.exports = __webpack_public_path__ + "img/action.86c3ef26.svg";